import React from 'react';
import Grid from '@material-ui/core/Grid';
import { HTMLPrinterAction } from 'services/Main/types.Component';
import { OnReactionExecuteEvent } from '../../../responseReactions/ReactionController';
import HTMLPrinterActionComponent from '../HTMLPrinterAction/HTMLPrinterAction';
import { useClassifyActions } from '../ExtraActions/useClassifyActions';
import ExtraActions from '../ExtraActions';
import HTMLPrinterActionButton from '../HTMLPrinterAction/HTMLPrinterActionButton';
import ExtraActionsMenuItem from '../ExtraActions/ExtraActions.MenuItem';

interface HTMLPrinterActionsProps {
  actions: HTMLPrinterAction[];
  onReactionExecute?: OnReactionExecuteEvent;
}

const HTMLPrinterActions = ({
  actions,
  onReactionExecute,
}: HTMLPrinterActionsProps) => {
  const { mainActions, extraActions } =
    useClassifyActions<HTMLPrinterAction>(actions);

  return (
    <Grid container alignItems="center" justify="flex-end" spacing={1}>
      {mainActions.map((actionProps) => (
        <Grid item key={`main_${Object.values(actionProps).join('')}`}>
          <HTMLPrinterActionComponent
            action={actionProps}
            onReactionExecute={onReactionExecute}
            renderAction={HTMLPrinterActionButton}
          />
        </Grid>
      ))}
      {extraActions.length > 0 ? (
        <Grid item>
          <ExtraActions<HTMLPrinterAction>
            actions={extraActions}
            renderMenuItem={(actionProps, onClickMenuItem) => (
              <HTMLPrinterActionComponent
                key={`extraAction_${Object.values(actionProps).join('')}`}
                action={actionProps}
                onClick={onClickMenuItem}
                onReactionExecute={onReactionExecute}
                renderAction={ExtraActionsMenuItem}
              />
            )}
          />
        </Grid>
      ) : null}
    </Grid>
  );
};

export default HTMLPrinterActions;
